<template>
  <span>
  <label :class="classList">
    <input :type="inputType"
           class="switch-input"
           :value="value"
           :checked= "value"
           :disabled="disabled"
           :name="name"
           @input="handleInput"
           @change="handleChange">
    <template v-if="isOn">
      <span class="switch-label" :data-on="on" :data-off="off"></span>
    </template>
    <template v-else>
      <span class="switch-label"></span>
    </template>
    <span class="switch-handle"></span>
  </label>
  <i v-if="disabled">{{$t('No es posible cambiar el estado')}}</i>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      default: true
    },
    disabled: {
      default: false
    },
    name: {
      default: 'default'
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    inputType: {
      type: String,
      default: 'radio'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList () {
      return [
        'switch',
        this.switchType,
        this.switchVariant,
        this.switchPill,
        this.switchSize
      ]
    },
    switchType () {
      return this.type ? `switch-${this.type}` : `switch-default`
    },
    switchVariant () {
      return this.variant ? `switch-${this.variant}` : `switch-secondary`
    },
    switchPill () {
      return !this.pill ? null : `switch-pill`
    },
    switchSize () {
      return this.size ? `switch-${this.size}` : ''
    },
    isChecked () {
      return this.checked ? 'checked' : ''
    },
    isOn () {
      return !this.on ? null : true
    }
  },
  methods: {
    handleChange (e) {
      let checked = e.target.checked
      this.$emit('change', checked)
    },
    handleInput (e) {
      let checked = e.target.checked
      this.$emit('input', checked)
    }

  }
}
</script>